import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type PublishContentConfigFragment = { defaultVersion?: Types.ResourceVersionTypeEnum | null, recalibrateConfig?: { recalibrateCompletedPerformances?: boolean | null, recalibrateInProgressPerformances?: boolean | null } | null };


export type PublishContentConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PublishContentConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment PublishContentConfig on PublishContentConfigPropertiesType {
  defaultVersion
  recalibrateConfig {
    recalibrateCompletedPerformances
    recalibrateInProgressPerformances
  }
}
    `;